import { jsx as _jsx } from "react/jsx-runtime";
import { ShortUrl } from "@air/api";
import { InlineInput } from "@air/component-inline-input";
import React, { memo, useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EditableMultilineTextTriggerButton } from "~/_components/InlineInput/EditableMultilineTextTriggerButton";
import { updateBoardCollectionClipsAction } from "~/store/boardCollection/actions";
import { boardCollectionFormSelector, boardCollectionSessionIdSelector, boardCollectionShortIdSelector } from "~/store/boardCollection/selectors";
const EDITABLE_DESCRIPTION_HEIGHT = 48;
export const ContentCollectionGalleryAssetDescription = /*#__PURE__*/ memo((param)=>{
    let { clip } = param;
    const dispatch = useDispatch();
    const sessionId = useSelector(boardCollectionSessionIdSelector);
    const form = useSelector(boardCollectionFormSelector);
    const shortId = useSelector(boardCollectionShortIdSelector);
    const [isEditing, setIsEditing] = useState(false);
    const [value, setValue] = useState(clip.description);
    useEffect(()=>{
        setValue(clip.description);
    }, [
        clip.description
    ]);
    const onSubmit = useCallback((newDescription)=>{
        if (!sessionId) {
            return;
        }
        dispatch(updateBoardCollectionClipsAction({
            clips: [
                {
                    ...clip,
                    description: newDescription !== null && newDescription !== void 0 ? newDescription : ""
                }
            ]
        }));
        ShortUrl.batchUpdateFormAssets(shortId, form.id, {
            formSessionId: sessionId,
            update: {
                description: !newDescription ? null : newDescription
            },
            assetIds: [
                clip.assetId
            ]
        });
    }, [
        clip,
        dispatch,
        form.id,
        sessionId,
        shortId
    ]);
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": "EDITABLE_CONTENT_COLLECTION_ASSET_DESCRIPTION",
        style: {
            height: EDITABLE_DESCRIPTION_HEIGHT
        },
        children: isEditing ? /*#__PURE__*/ _jsx(InlineInput, {
            label: "Asset description",
            onSubmit: (value)=>{
                setIsEditing(false);
                onSubmit(value);
            },
            onCancel: ()=>{
                setValue(clip.description);
                setIsEditing(false);
            },
            onChange: setValue,
            className: "-ml-px h-full pt-px",
            inputClassName: "text-14 text-grey-11 py-1 px-1 -mt-0.5",
            defaultValue: value,
            placeholder: "Add a description here…"
        }) : /*#__PURE__*/ _jsx(EditableMultilineTextTriggerButton, {
            placeholder: "Add a description here…",
            onClick: ()=>setIsEditing(true),
            className: "size-full px-1 text-14",
            value: value
        })
    });
});
ContentCollectionGalleryAssetDescription.displayName = "ContentCollectionGalleryAssetDescription";
